"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.array.find");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _MessageInputText = _interopRequireDefault(require("./MessageInputText.vue"));
var _index = _interopRequireDefault(require("@/components/HighlightTextarea/index.vue"));
var _lightEditor = _interopRequireDefault(require("@/components/lightEditor/lightEditor.vue"));
var _lightInput = _interopRequireDefault(require("@/components/lightEditor/lightInput.vue"));
var _MsgCheckTextDialog = _interopRequireDefault(require("@/views/booking/bookingSpace/components/MsgCheckTextDialog.vue"));
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    LightEditor: _lightEditor.default,
    MsgCheckTextDialog: _MsgCheckTextDialog.default,
    LightInput: _lightInput.default
  },
  props: {
    form: {
      type: Object
    },
    cargoList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bookingTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    transportationTermsList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    paidTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rules: {
      type: Object
    },
    packageTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    consigneeCheck: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    titleFlag: {
      type: String,
      default: ''
    },
    isShowRequired: {
      type: Boolean,
      default: true
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  //  "sequence": 1,//1 客户名称，2  地址，7   国家，8  电话，9   邮箱，10  传真，15  企业代码，16   AEO代码
  data: function data() {
    return {
      isShow: true,
      isMaterials: false,
      sequence: ['1', '2', '7', '8', '9', '10', '15', '16'],
      catalogContent: '',
      // 当前父组件文本框的内容
      catalogContentIndex: 0 // 当前修改的数据是哪一条
    };
  },
  mounted: function mounted() {
    this.isMaterials = this.$route.path.indexOf("bookMaterialsDetail") !== -1;
    this.isShow = !this.isMaterials;
    // webBkCusCatalogComs=[{a:111,sequence:'',rowstatus:4},{a:22,sequence:'7',rowstatus:4}]
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  methods: {
    validateNull: _validate.validateNull,
    getCatalogComs: function getCatalogComs() {
      // 找到 customer 为 0 的对象
      var customerObject = this.form.webBkCustomerComs.find(function (item) {
        return item.customerType === 1;
      });
      // 如果找到了该对象，返回它的 webBkCusCatalogComs；否则返回空数组
      return customerObject ? customerObject.webBkCusCatalogComs : [];
    },
    inputClass: function inputClass(fileName) {
      return {
        'different': this.isDifferent(fileName)
      };
    },
    isDifferent: function isDifferent(fileName) {
      return this.consigneeCheck.includes(fileName);
    },
    handleOpen: function handleOpen() {
      this.isShow = !this.isShow;
    },
    handleChangePeople: function handleChangePeople(item) {
      if (item.sequence === '2') {
        item.catalogContent = item.catalogContent.toUpperCase();
      }
      if (item.sequence === '1') {
        item.catalogContent = item.catalogContent.toUpperCase();
        this.form.webBkCustomerComs[0].customerName = item.catalogContent;
      }
      if (item.sequence === '9' || item.sequence === '13') {
        var array = item.catalogContent.split(";");
        var emailPattern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        for (var i = 0; i < array.length; i++) {
          if (!emailPattern.test(array[i])) {
            item.catalogContent = '';
            this.$message({
              message: this.$t('home.emailRequire'),
              type: 'warning'
            });
          }
        }
      }
    },
    showName: function showName(item) {
      var mapObject = {
        '1': this.$t('home.consignerReceive'),
        '2': this.$t('home.consignerReceiveAddress'),
        '7': this.$t('home.consignerCountry'),
        '8': this.$t('home.consignerPhone'),
        '9': this.$t('home.consignerEmail'),
        '10': this.$t('home.consignerFax'),
        '11': this.$t('home.connetName'),
        '12': this.$t('home.connetPhone'),
        '13': this.$t('home.connetEmail'),
        '14': this.$t('home.connetFax'),
        '15': this.$t('home.consignerEnterpriseCode'),
        '16': this.$t('home.consignerAEOCode'),
        '3': this.$t('home.notifierCity'),
        '5': this.$t('home.notifierProvince'),
        '6': this.$t('home.notifierPostalCode')
      };
      return mapObject[item.sequence];
    },
    // 打开提示框
    openDialog: function openDialog(biteLength) {
      this.$refs.myDialog.openDialog(biteLength);
    },
    // 传入信息
    handleText: function handleText(item, index) {
      this.catalogContent = item.catalogContent;
      this.catalogContentIndex = index;
    },
    // 提交
    confirm: function confirm(inpText) {
      var _this = this;
      this.getCatalogComs().forEach(function (item, index) {
        if (_this.catalogContentIndex === index) {
          item.catalogContent = inpText;
        }
      });
    },
    // 监听复制
    onCopy: function onCopy(e, item) {
      e.preventDefault();
      if (item.catalogContent && e.clipboardData) {
        e.clipboardData.setData('text/plain', item.catalogContent);
      } else if (item.catalogContent && window.clipboardData) {
        window.clipboardData.setData('text', item.catalogContent);
      }
    }
  }
};